import Reveal from "@/components/site/Reveal";

export default function DestinationTile({ destination, delay = 0 }) {
  return (
    <Reveal delay={delay}>
      <article id={destination.id} data-testid={`destination-${destination.id}`} className="scroll-mt-32">
        {destination.image && (
          <img
            src={destination.image.src}
            alt={destination.image.alt}
            loading="lazy"
            className="aspect-[3/2] w-full rounded-2xl object-cover"
          />
        )}
        <div className="mt-6 flex items-baseline justify-between gap-4 border-t border-line pt-5">
          <h3 className="text-xl font-medium tracking-tight sm:text-2xl">{destination.name}</h3>
          <span className="shrink-0 text-xs font-semibold uppercase tracking-[0.18em] text-brass">
            Coming Soon
          </span>
        </div>
        <p className="mt-3 text-base leading-relaxed text-ink/75">{destination.teaser}</p>
        <p className="mt-4 text-sm text-ink/55">{destination.themes.join("  ·  ")}</p>
      </article>
    </Reveal>
  );
}
